import React from 'react';

// Extracted from LessonWorkspace.js (Phase 3 of the platform-health plan:
// split the file mechanically, without changing behavior). The two
// floating buttons ("Add to Dictionary" / "Translate") shown next to a
// text selection, plus the translation result popup they can trigger.
export default function SelectionContextMenu({
  contextMenu,
  hoveredButton,
  onHoverButton,
  onAddToDictionary,
  onTranslate,
  translation,
}) {
  return (
    <>
      {/* Context Menu - Save Button */}
      {contextMenu.show && (
        <div
          className="context-menu"
          style={{
            position: 'fixed',
            top: contextMenu.y,
            left: contextMenu.x - 20,
            background: '#fff',
            border: '1px solid #e0e0e0',
            borderRadius: '6px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            zIndex: 10000,
            minWidth: '32px',
            padding: '0'
          }}
          onClick={e => e.stopPropagation()}
        >
          <button
            onClick={onAddToDictionary}
            style={{
              width: '100%',
              padding: '6px 8px',
              background: 'transparent',
              border: 'none',
              textAlign: 'center',
              cursor: 'pointer',
              fontSize: '12px',
              color: '#666',
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative'
            }}
            onMouseEnter={e => {
              e.target.style.background = '#f5f5f5';
              onHoverButton('save');
            }}
            onMouseLeave={e => {
              e.target.style.background = 'transparent';
              onHoverButton(null);
            }}
          >
            <svg width="12" height="12" viewBox="0 0 511.958 511.958" fill="currentColor">
              <path d="m400.579 0h-289.2c-25.487 0-47.133 20.556-47.133 47.133v427.63c.075 33.733 41.277 49.561 64.701 25.882l110.235-110.204c8.834-9.216 24.76-9.216 33.594 0l110.235 110.204c23.434 23.688 64.631 7.836 64.701-25.882v-427.63c0-26.577-21.646-47.133-47.133-47.133z"/>
            </svg>
            {hoveredButton === 'save' && (
              <div style={{
                position: 'absolute',
                top: '-30px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: '#666',
                color: '#fff',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '11px',
                whiteSpace: 'nowrap',
                zIndex: 10001
              }}>
                Add to Dictionary
              </div>
            )}
          </button>
        </div>
      )}

      {/* Context Menu - Translate Button */}
      {contextMenu.show && (
        <div
          className="context-menu"
          style={{
            position: 'fixed',
            top: contextMenu.y,
            left: contextMenu.x + 20,
            background: '#fff',
            border: '1px solid #e0e0e0',
            borderRadius: '6px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            zIndex: 10000,
            minWidth: '32px',
            padding: '0'
          }}
          onClick={e => e.stopPropagation()}
        >
          <button
            onClick={onTranslate}
            style={{
              width: '100%',
              padding: '6px 8px',
              background: 'transparent',
              border: 'none',
              textAlign: 'center',
              cursor: 'pointer',
              fontSize: '12px',
              color: '#666',
              transition: 'all 0.2s ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative'
            }}
            onMouseEnter={e => {
              e.target.style.background = '#f5f5f5';
              onHoverButton('translate');
            }}
            onMouseLeave={e => {
              e.target.style.background = 'transparent';
              onHoverButton(null);
            }}
          >
            <svg width="12" height="12" viewBox="0 0 512 512" fill="currentColor">
              <g>
                <line stroke="currentColor" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" x1="100" y1="140" x2="180" y2="140"/>
                <line stroke="currentColor" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" x1="140" y1="100" x2="140" y2="140"/>
                <path stroke="currentColor" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M412,412v-80c0-22.091-17.909-40-40-40s-40,17.909-40,40v80"/>
                <line stroke="currentColor" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" x1="412" y1="372" x2="332" y2="372"/>
                <path stroke="currentColor" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M180,220c-24.515-12.257-40-37.313-40-64.721V140"/>
                <path stroke="currentColor" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M100,220c24.515-12.257,40-37.313,40-64.721V140"/>
                <path stroke="currentColor" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M332,212h80c44.183,0,80,35.817,80,80v120c0,44.183-35.817,80-80,80h-80c-44.183,0-80-35.817-80-80v-61.468"/>
                <path stroke="currentColor" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M260,220c0,44.183-35.817,80-80,80h-80c-44.183,0-80-35.817-80-80V100c0-44.183,35.817-80,80-80h80c44.183,0,80,35.817,80,80V220z"/>
                <path stroke="currentColor" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M336,60h80c22.091,0,40,17.909,40,40v40"/>
                <path stroke="currentColor" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" fill="none" d="M56,372v40c0,22.091,17.909,40,40,40h80"/>
                <polyline stroke="currentColor" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" fill="none" points="136,412 176,452 136,492"/>
                <polyline stroke="currentColor" strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" fill="none" points="376,100 336,60 376,20"/>
              </g>
            </svg>
            {hoveredButton === 'translate' && (
              <div style={{
                position: 'absolute',
                top: '-30px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: '#666',
                color: '#fff',
                padding: '4px 8px',
                borderRadius: '4px',
                fontSize: '11px',
                whiteSpace: 'nowrap',
                zIndex: 10001
              }}>
                Translate
              </div>
            )}
          </button>
        </div>
      )}

      {/* Translation Popup */}
      {translation && (
        <div
          style={{
            position: 'fixed',
            top: contextMenu.y + 50,
            left: contextMenu.x,
            transform: 'translateX(-50%)',
            background: '#fff',
            border: '1px solid #e0e0e0',
            borderRadius: '6px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            zIndex: 10001,
            padding: '8px 12px',
            maxWidth: '200px',
            fontSize: '12px',
            color: '#333'
          }}
          onClick={e => e.stopPropagation()}
        >
          <div>
            {translation}
          </div>
        </div>
      )}
    </>
  );
}
